// Coach Updates block schema - Auto-synced bulletin showing latest posted update
export const coachUpdatesSchema = {
  type: 'coach-updates',
  label: 'Coach Updates',
  description: 'Auto-synced bulletin showing your latest posted update',
  icon: 'ClipboardList',
  defaultContent: {
    fallbackHeading: 'Latest Update',
    fallbackBody: 'No updates posted yet.',
    style: {},
  },
  fields: [],
};
